module.exports = __webpack_public_path__ + "static/media/pasar-itv.c5a5e550.png";